import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';

export default function Forbidden() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6">
      <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6"
        style={{ background: 'linear-gradient(135deg,#3B1111,#7F1D1D)' }}>
        <ShieldOff size={28} className="text-red-400" />
      </div>
      <h1 className="text-2xl font-bold text-text mb-2">Access Denied</h1>
      <p className="text-text-muted text-sm max-w-sm mb-6">
        You don't have permission to perform this action.
        Contact your administrator if you believe this is an error.
      </p>
      <button onClick={() => navigate(-1)} className="btn-secondary">Go Back</button>
    </div>
  );
}
